import { useEffect, useState } from "react"
import { Container, Card, CardContent, Typography, Grid, Divider } from "@mui/material"
import { styled } from "@mui/material/styles"
import { useBusiness } from "../hooks/Contexts/BusinessContext/BusinessContext"
import { useApiService } from "../hooks/Api/useApiService"
import UsersList from "./UsersList"
import BusinessList from "./BusinessList"
import useDeviceType from "../hooks/Utils/useDeviceType"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import BusinessDetails from "./BusinessDetails"

const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(4),
  marginTop: theme.spacing(5),
  boxShadow: theme.shadows[4],
  borderRadius: theme.spacing(1.5),
}))

const BusinessPage = () => {
  const [businesses, setBusinesses] = useState([])
  const [users, setUsers] = useState([])
  const { context_business } = useBusiness()
  const { getData, postData } = useApiService()
  const deviceType = useDeviceType()
  const isDesktop = deviceType === "desktop"
  const t = useTranslationSharie()

  useEffect(() => {
    postData("business/getbusinessusers", { name: context_business?.name })
      .then((data) => {
        setUsers(data?.users || [])
        return getData("business/getbusinesses")
      })
      .then((data) => {
        setBusinesses(data?.businesses || [])
      })
  }, [context_business?.name])

  return (
    <T>
      <div
        style={
          isDesktop
            ? { display: "flex", justifyContent: "space-between", width: "100%", marginTop: "20px" }
            : {
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "20px",
              }
        }
      >
        {isDesktop && (
          <div style={{ flex: 1, margin: "0 10px", minWidth: "300px" }}>
            <UsersList users={users} />
          </div>
        )}
        <div style={{ flex: 1, margin: "0 10px", minWidth: "300px" }}>
          <BusinessDetails context_business={context_business} />
        </div>

        {!isDesktop && (
          <div style={{ flex: 1, margin: "1rem", minWidth: "300px" }}>
            <UsersList users={users} />
          </div>
        )}
        <div style={{ flex: 1, margin: "0 10px", minWidth: "300px" }}>
          <BusinessList businesses={businesses} />
        </div>
      </div>
    </T>
  )
}

export default BusinessPage
